<template>
  <a @click="clickDeleteFavouriteGroup()" class="card-footer-item" :class="deleteButtonClass">{{ deleteText }}</a>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      deleteClickCounter: 0,
      deleteText: 'Удалить'
    };
  },
  props: {
    favouriteGroup: {
      type: Object,
      required: true
    }
  },
  computed: {
    deleteButtonClass() {
      return {
        'has-text-danger': this.deleteClickCounter == 0,
        'has-text-white': this.deleteClickCounter >= 1,
        'has-background-danger': this.deleteClickCounter >= 1
      };
    }
  },
  methods: {
    ...mapActions('favourites', {
      removeFavouriteGroup: 'removeFavouriteGroup'
    }),
    toast(toast) {
      this.$buefy.toast.open({
        message: toast.message,
        type: toast.type,
        position: 'is-bottom'
      });
    },
    clickDeleteFavouriteGroup() {
      let timeout = setTimeout(() => {
        this.deleteClickCounter = 0;
        this.deleteText = 'Удалить';
      }, 2000);

      this.deleteClickCounter++;
      this.deleteText = 'Уверены?';
      timeout;

      if (this.deleteClickCounter >= 2) {
        this.removeFavouriteGroup(this.favouriteGroup.id);
        this.deleteClickCounter = 0;
        this.deleteText = 'Удалить';
        this.toast({
          message: 'Группа удалена',
          type: 'is-danger'
        });
        clearTimeout(timeout);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card-footer-item {
  user-select: none;
}
</style>
